module.exports = __webpack_public_path__ + "img/banner-2.934f686e.png";